"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizationSaga = exports.createAuthorizationSaga = void 0;
const effects_1 = require("redux-saga/effects");
// import {
//   ContractData,
//   getContract,
//   sendMetaTransaction
// } from 'decentraland-transactions'
const eth_1 = require("../../lib/eth");
// import { getChainConfiguration } from '../../lib/chainConfiguration'
const utils_1 = require("./utils");
const actions_1 = require("./actions");
const types_1 = require("./types");
// @ts-ignore
function createAuthorizationSaga(options) {
    return function* authorizationSaga() {
        yield effects_1.takeEvery(actions_1.FETCH_AUTHORIZATIONS_REQUEST, handleFetchAuthorizationsRequest);
        yield effects_1.takeEvery(actions_1.GRANT_TOKEN_REQUEST, handleGrantTokenRequest);
        yield effects_1.takeEvery(actions_1.REVOKE_TOKEN_REQUEST, handleRevokeTokenRequest);
    };
    function* handleFetchAuthorizationsRequest(action) {
        const { authorizations } = action.payload;
        try {
            const promises = [];
            // const multicallProviders: Record<string, providers.MulticallProvider> = {}
            for (const authorization of authorizations) {
                if (!utils_1.isValidType(authorization.type)) {
                    throw new Error(`Invalid authorization type ${authorization.type}`);
                }
                if (authorization.authorizedAddress.startsWith('0x') || authorization.contractAddress.startsWith('0x'))
                    continue;
                // const { chainId } = authorization
                // if (!multicallProviders[chainId]) {
                //   // provider party 🎉
                //   const provider: Provider = yield call(() =>
                //     getNetworkProvider(chainId)
                //   )
                //   const ethersProvider = new ethersProviders.Web3Provider(provider)
                //   const multicallProvider = new providers.MulticallProvider(
                //     ethersProvider
                //   )
                //   multicallProviders[chainId] = multicallProvider
                // }
                const tronWeb = window.tronWeb;
                switch (authorization.type) {
                    case types_1.AuthorizationType.ALLOWANCE:
                        break;
                    case types_1.AuthorizationType.APPROVAL:
                        // @ts-ignore
                        let contract = yield tronWeb.contract().at(authorization.contractAddress);
                        console.log('handle auth authorized address: ' + authorization.authorizedAddress);
                        console.log('handle auth contract address: ' + authorization.contractAddress);
                        console.log('handle auth address: ' + authorization.address);
                        promises.push(
                        // @ts-ignore
                        contract
                            .isApprovedForAll(authorization.address, authorization.authorizedAddress).call()
                            .then((isApproved) => isApproved ? authorization : null)
                            .catch((error) => {
                            console.warn(`Error fetching approval`, authorization, error);
                            return null;
                        }));
                        break;
                }
            }
            const authorizationsToStore = yield effects_1.call(() => __awaiter(this, void 0, void 0, function* () {
                const results = yield Promise.all(promises);
                console.log(results);
                return results.filter(result => !!result); // filter nulls, or undefineds due to caught promises
            }));
            yield effects_1.put(actions_1.fetchAuthorizationsSuccess(authorizationsToStore));
        }
        catch (error) {
            yield effects_1.put(actions_1.fetchAuthorizationsFailure(authorizations, error.message));
        }
    }
    function* handleGrantTokenRequest(action) {
        const { authorization } = action.payload;
        try {
            const txHash = yield effects_1.call(() => changeAuthorization(authorization, types_1.AuthorizationAction.GRANT));
            yield effects_1.put(actions_1.grantTokenSuccess(authorization, authorization.chainId, txHash));
        }
        catch (error) {
            yield effects_1.put(actions_1.grantTokenFailure(authorization, error.message));
        }
    }
    function* handleRevokeTokenRequest(action) {
        const { authorization } = action.payload;
        try {
            const txHash = yield effects_1.call(() => changeAuthorization(authorization, types_1.AuthorizationAction.REVOKE));
            yield effects_1.put(actions_1.revokeTokenSuccess(authorization, authorization.chainId, txHash));
        }
        catch (error) {
            yield effects_1.put(actions_1.revokeTokenFailure(authorization, error.message));
        }
    }
    function changeAuthorization(authorization, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!utils_1.isValidType(authorization.type)) {
                throw new Error(`Invalid authorization type ${authorization.type}`);
            }
            const provider = yield eth_1.getConnectedProvider();
            if (!provider) {
                throw new Error('Could not connect to TRON');
            }
            // const eth: Eth = new Eth(provider)
            // const { network } = getChainConfiguration(authorization.chainId)
            if (authorization.type === types_1.AuthorizationType.ALLOWANCE) {
                return "";
            }
            // const from = authorization.address
            const contractAddress = authorization.contractAddress;
            const authorizedAddress = authorization.authorizedAddress;
            // const { contractName, chainId } = authorization
            const tronWeb = window.tronWeb;
            const isApproved = action === types_1.AuthorizationAction.GRANT;
            // @ts-ignore
            let contract = yield tronWeb.contract().at(contractAddress);
            return yield contract.setApprovalForAll(authorizedAddress, isApproved).send();
            // switch (network) {
            //   case Network.ETHEREUM:
            //   case Network.MATIC:
            //     const payload = method.getSendRequestPayload({ from })
            //     const txData = payload.params[0].data
            //     const metaTxProvider = await getNetworkProvider(chainId)
            //     const contract: ContractData = {
            //       ...getContract(contractName, chainId),
            //       address: contractAddress.toString()
            //     }
            //
            //     return sendMetaTransaction(provider, metaTxProvider, txData, contract, {
            //       serverURL: options?.metaTransactionServerUrl
            //     })
            // }
        });
    }
}
exports.createAuthorizationSaga = createAuthorizationSaga;
exports.authorizationSaga = createAuthorizationSaga();
//# sourceMappingURL=sagas.js.map